import {
  ref, computed, nextTick, watch,
} from '@vue/composition-api'

// Notification
import store from '@/store'
import i18n from '@/libs/i18n'
import { transformDateToHumanReadablePretty } from '@/helpers/dateTimeHelper'

export default () => {
  const refOrganizationInvoiceListTable = ref(null)
  const queryParams = ref({
    perPage: 10,
    page: 1,
  })

  const loading = ref(false)
  const items = ref(0)
  const totalItems = ref(0)
  const list = ref([])
  const dataMeta = computed(() => ({
    from: queryParams.value.perPage * (queryParams.value.page - 1) + (totalItems.value ? 1 : 0),
    to: queryParams.value.perPage * (queryParams.value.page - 1) + items.value,
    of: totalItems.value,
  }))

  const fetchData = () => {
    loading.value = true
    nextTick(() => {
      store.dispatch('organization/fetchInvoices', {
        params: {
          limit: queryParams.value.perPage,
          offset: (queryParams.value.page - 1) * queryParams.value.perPage,
        },
      })
        .then(res => {
          list.value = res.data.items
          items.value = res.data.filtered
          totalItems.value = res.data.total
        })
        .finally(() => {
          loading.value = false
        })
    })
  }
  fetchData()

  watch(() => queryParams.value, () => {
    fetchData()
  }, { deep: true })

  const tableColumns = ref(
    [
      {
        key: 'invoiceNumber',
        label: i18n.t('organization.invoices.table-label.invoice-number'),
        sortable: false,
      },
      {
        key: 'invoiceDate',
        label: i18n.t('organization.invoices.table-label.invoice-date'),
        sortable: false,
      },
      {
        key: 'value',
        label: i18n.t('organization.invoices.table-label.value'),
        sortable: false,
      },
      {
        key: 'actions',
        label: '',
        sortable: false,
      },
    ],
  )

  const downloadInvoice = invoiceId => {
    store.dispatch('organization/downloadInvoice', invoiceId)
      .then(response => {
        const contentType = response.headers['content-type'] || 'application/octet-stream'
        const blob = new Blob([response.data], { type: contentType })

        let filename = `invoice_${invoiceId}.pdf`
        const contentDisp = response.headers['content-disposition']
        if (contentDisp) {
          const match = /filename\*?=(?:UTF-8'')?"?([^";\r\n]+)"?/.exec(contentDisp)
          if (match && match[1]) {
            filename = decodeURIComponent(match[1])
          }
        }

        const blobUrl = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = blobUrl
        a.download = filename
        document.body.appendChild(a)
        a.click()

        window.URL.revokeObjectURL(blobUrl)
        a.remove()

        return filename
      })
      .catch(err => {
        throw err
      })
  }

  return {
    loading,
    totalItems,
    dataMeta,
    queryParams,
    refOrganizationInvoiceListTable,
    tableColumns,
    list,
    fetchData,
    transformDateToHumanReadablePretty,
    downloadInvoice,
  }
}
